import { Action } from '@ngrx/store';
import { type } from './utils/util';
import { Dock } from "../models/Dock";
import { CustomAction } from "./utils/action";

const initialState = []

const ActionTypes = {
  DOCK_STATUS_UPDATE: type("DOCK_STATUS_UPDATE"),
  DOCK_STATUS_UPDATE_BY_UUID: type("DOCK_STATUS_UPDATE_BY_UUID"),
  DOCK_CREATE: type("DOCK_CREATE"),
  DOCK_UPDATE: type("DOCK_UPDATE"),
}

export class DockStatusUpdate implements Action {
  type = ActionTypes.DOCK_STATUS_UPDATE
  payload: {
    id: Number,
    dock: Dock
  }

  constructor(args: { id: Number, dock: Dock }) {
    this.payload = args
  }
}

export class DockStatusUpdateByUuid implements Action {
  type = ActionTypes.DOCK_STATUS_UPDATE_BY_UUID
  payload: {
    uuid: String,
    dock: Dock
  }

  constructor(args: { uuid: String, dock: Dock }) {
    this.payload = args
  }
}

export class DockUpdate implements Action {
  type = ActionTypes.DOCK_UPDATE
  payload: {
    dock: Dock
  }

  constructor(args: { dock: Dock }) {
    this.payload = args
  }
}

export class DockCreate implements Action {
  type = ActionTypes.DOCK_CREATE
  payload: {
    dock: Dock
  }

  constructor(args: { dock: Dock }) {
    this.payload = args
  }
}

export function DockReducer(state = initialState, action: CustomAction) {
  switch (action.type) {
    case ActionTypes.DOCK_CREATE:
      return [...state, action.payload];
    case ActionTypes.DOCK_STATUS_UPDATE:
      return state.map((dock) => {
        if (dock.id == action.payload.id) {
          return Object.assign(dock, action.payload.dock);
        }
        return dock;
      });

    case ActionTypes.DOCK_STATUS_UPDATE_BY_UUID:
      return state.map((dock) => {
        if (dock.uuid == action.payload.uuid) {
          let d = dock;
          d.current.status = 0;
          return Object.assign(dock, d);
        }
        return dock;
      });
    case ActionTypes.DOCK_UPDATE:
      return state.map((dock) => {
        if (dock.id == action.payload.dock.id) {
          return Object.assign(dock, action.payload.dock);
        }
        return dock;
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/states/dock.reducer.ts